
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#FFF","d":"M22.523 0c2.72 0 4.926 2.222 4.926 4.949h5.862a3.591 3.591 0 013.59 3.599v.223h4.511a3.595 3.595 0 013.588 3.6v41.725a3.59 3.59 0 01-3.588 3.596H3.588A3.595 3.595 0 010 54.096V12.37c0-1.988 1.6-3.599 3.583-3.599H8.1v-.223a3.597 3.597 0 013.59-3.6h5.862C17.551 2.216 19.76 0 22.477 0zM8.099 10.121H3.583a2.24 2.24 0 00-2.238 2.25v41.725a2.246 2.246 0 002.243 2.246h37.824a2.242 2.242 0 002.242-2.246V12.37c0-1.24-1.005-2.249-2.242-2.249h-4.511v3.374H8.099V10.12zm27.456 0V8.548a2.244 2.244 0 00-2.244-2.25h-7.205v-1.35a3.594 3.594 0 00-3.583-3.598h-.045a3.593 3.593 0 00-3.584 3.599v1.35H11.69a2.247 2.247 0 00-2.245 2.249v1.573h.005v2.024H35.55V10.12h.004z"}}),_c('path',{attrs:{"stroke":"#BF9C5F","stroke-width":"2","d":"M30.825 47.56a.325.325 0 01-.324-.326c0-.178.148-.326.324-.326H8.775c.176 0 .324.147.324.326a.328.328 0 01-.324.326h22.05zm2.704-5.736a.326.326 0 110-.652H8.771a.326.326 0 110 .652h24.758zm2.703-6.298a.33.33 0 01-.331-.327c0-.179.144-.324.33-.324H8.77a.33.33 0 01.33.324.325.325 0 01-.33.327h27.463zm-4.508-6.297a.328.328 0 01-.324-.326c0-.178.148-.326.324-.326H8.775a.327.327 0 010 .652h22.949zm-13.5-6.299a.325.325 0 010-.65H8.776c.177 0 .324.147.324.324 0 .18-.146.326-.324.326h9.45z"}})])])
          )
        }
      }
    